export default function Appointment() {
    return (
      <iframe
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3kNvvDc9CJgP-jMH6ilNt5aNF2kTTVpj8sChpcYWITTP5HsVfoSbq7nIyfb2gYz_W1Wy2XJnBm?gv=true"
        style={{ border: "0" }}
        width="100%"
        height="1000"
        title="Book an Appointment"
        position= "Right"
      />
    );
  }
  